import { createColumnHelper } from '@tanstack/react-table';
import { lt } from '@mews/framework';
import { ColumnFilterType } from '@optimus-web/core';
import { getBasePriceFieldName } from '../../../forms/schemas/configureProductFormSchema';
import { BasePriceCell } from '../../common/BasePriceCell';
import { PricingTableData } from '../../../../types';

const columnHelper = createColumnHelper<PricingTableData>();

export const getColumns = (selectedCountries: string[], selectedCurrencies: string[]) => [
    columnHelper.accessor('name', {
        header: () => lt('GeneralProperty'),
    }),
    columnHelper.accessor('cityName', {
        header: () => lt('City'),
    }),
    columnHelper.accessor('countryName', {
        header: () => lt('Country'),
        enableColumnFilter: true,

        meta: {
            filtersType: ColumnFilterType.MultiSelect,
            getMultiSelectOptions: () =>
                selectedCountries.map((value) => ({
                    value,
                    label: value,
                })),
        },
    }),
    columnHelper.accessor('defaultCurrencyCode', {
        header: () => lt('BasePriceExcludeTax'),
        enableColumnFilter: true,
        meta: {
            filtersType: ColumnFilterType.MultiSelect,
            getMultiSelectOptions: () => selectedCurrencies.map((value) => ({ value, label: value })),
        },
        cell: (props) => {
            const {
                id,
                original: { defaultCurrencyCode },
            } = props.row;
            const fieldName = getBasePriceFieldName(id);

            return <BasePriceCell fieldName={fieldName} defaultCurrencyCode={defaultCurrencyCode} />;
        },
    }),
];
